import React, { useEffect, useState, useMemo } from 'react';
import styles from './index.module.scss';
import { Charts } from '../../components/Icons';
import { LISTEN_STEP_CONDITION_CHANGE } from '../Step2Selector';
import DATA_TYPES, { ALL_CHART_TYPES } from '../DATA_TYPES';

const CHARTS = {
    BAR: {
        icon: <Charts.Bar />,
        value: ALL_CHART_TYPES.BAR,
        name: "柱狀圖",
    },
    STACK_BAR: {
        icon: <Charts.StackBar />,
        value: ALL_CHART_TYPES.STACK_BAR,
        name: "堆疊柱狀圖",
    },
    GROUPED_BAR: {
        icon: <Charts.GroupedBar />,
        value: ALL_CHART_TYPES.GROUPED_BAR,
        name: "分組柱狀圖",
    },
    PIE: {
        icon: <Charts.Pie />,
        value: ALL_CHART_TYPES.PIE,
        name: "圓餅圖",
    },
    LINE: {
        icon: <Charts.Line />,
        value: ALL_CHART_TYPES.LINE,
        name: "折線圖",
    },
    HEATMAP: {
        icon: <Charts.Heatmap />,
        value: ALL_CHART_TYPES.HEATMAP,
        name: "熱力圖",
    },
    MOSAIC: {
        icon: <Charts.Mosaic />,
        value: ALL_CHART_TYPES.MOSAIC,
        name: "馬賽克圖",
    },
    MULTIPLE_LINE: {
        icon: <Charts.MultipleLine />,
        value: ALL_CHART_TYPES.MULTIPLE_LINE,
        name: "多條折線圖",
    },
};

export const LISTEN_CHART_TYPE_CHANGE = (callback) => {
    document.addEventListener('chartTypeChange', callback);
}

export const UNLISTEN_CHART_TYPE_CHANGE = (callback) => {
    document.removeEventListener('chartTypeChange', callback);
}

function Step3Selector() {
    const [currentChartType, setCurrentChartType] = useState(null);
    const [steps, setSteps] = useState({
        step1Type: null,
        step2Type: null,
        step3Type: null,
    });

    const availableCharts = useMemo(() => {
        const { step1Question, step2Question, step3Question } = steps;

        
        if (!step1Question && !step2Question && !step3Question) {
            return [];
        }

        if (step1Question && step2Question && step3Question) {
            return [
                CHARTS.HEATMAP,
                CHARTS.GROUPED_BAR,
            ]
        }

        if (step1Question.AnswerTypeName === DATA_TYPES.數值型單數 && !step2Question && !step3Question) {
            return [];
        }

        let result = [];

        if (step1Question && !step2Question && !step3Question) {
            result = [CHARTS.BAR, CHARTS.PIE];

            if (step1Question.AnswerTypeName === DATA_TYPES.數值型級距) {
                result.push(CHARTS.LINE);
            }
        }


        if (step1Question && step2Question) {
            if (
                step1Question.AnswerTypeName !== DATA_TYPES.數值型單數 &&
                step2Question.AnswerTypeName !== DATA_TYPES.數值型單數
            ) {
                result = [CHARTS.STACK_BAR, CHARTS.MOSAIC, CHARTS.HEATMAP];
            } else if (
                step1Question.AnswerTypeName === DATA_TYPES.數值型單數 &&
                step2Question.AnswerTypeName !== DATA_TYPES.數值型單數
            ) {
                result = [CHARTS.BAR];
            } else {
                result = [CHARTS.BAR, CHARTS.PIE];
            }

            if (step1Question.AnswerTypeName === DATA_TYPES.數值型單數 && step2Question.AnswerTypeName === DATA_TYPES.數值型級距) {
                result.push(CHARTS.LINE);
            }

        }


        return result;
        
    }, [steps]);

    useEffect(() => {
        LISTEN_STEP_CONDITION_CHANGE((e) => {
            const { step1Question, step2Question, step3Question } = e.detail;
            setSteps({
                step1Question,
                step2Question,
                step3Question,
            });
        });
    }, []);

    const handleChartTypeSelect = (chartType) => {
        if (!chartType) {
            setCurrentChartType(null);
            const customEvent = new CustomEvent("chartTypeChange", {
                detail: {
                    chartType: null,
                },
            });

            document.dispatchEvent(customEvent);
            return;
        }
        setCurrentChartType(chartType.value);
        const customEvent = new CustomEvent("chartTypeChange", {
            detail: {
                chartType: chartType.value,
            },
        });

        document.dispatchEvent(customEvent);
    };

    useEffect(() => {
        handleChartTypeSelect(null);
        
    }, [availableCharts]);


    
    return (
        <div className={styles.step3Selector}>
            <h3>STEP3：選擇欲生成圖表類型</h3>
            <div className={styles.chartContainer}>
                {availableCharts.length === 0 ? (
                    <b>此組項目尚無適用圖表，請重新選擇或繼續追加項目</b>
                ) : (
                    availableCharts.map((chart) => (
                        <button
                            key={chart.value}
                            onClick={() => handleChartTypeSelect(chart)}
                            className={
                                currentChartType === chart.value
                                    ? "-active"
                                    : ""
                            }
                        >
                            {chart.icon}
                            <div className={styles.chartName}>{chart.name}</div>
                        </button>
                    ))
                )}
            </div>
        </div>
    );
}

export default Step3Selector;